import * as React from "react";
import { ARROW_LEFT_SVG, ARROW_RIGHT_SVG } from 'bpm-web-generic';
import { CoverListItem } from "./CoverList";

const NEWS_HEIGHT = 280
const NEWS_WIDTH = NEWS_HEIGHT / 9 * 16
const LARGE_IMG = 280
const XLARGE_IMG = 480
const SMALL_IMG = 160
const VIDEO_IMG_H = 180
const VIDEO_IMG_W = VIDEO_IMG_H / 9 * 16
const MARGIN_L = 15
const MARGIN_S = 10
export interface Item {
    id: string, image: string, title: string, subTitle?: string; onClick: () => void
}
export interface HorizontalListProps {
    items: Item[]
    size: "small" | "large" | "video" | "news" | "xlarge",
    renderItem?: (item: Item) => React.ReactNode
    style?: React.CSSProperties
    itemStyle?: React.CSSProperties
    headline?: string
    onViewAllClick?: () => void
}

export class HorizontalList extends React.Component<HorizontalListProps, { leftArrowDisabled: boolean, rightArrowDisabled: boolean, showArrows: boolean }> {
    private container: HTMLDivElement | null = null;
    private scrollView: HTMLDivElement | null = null;
    private scrollRequestCode: number = 0;


    constructor(props: any) {
        super(props);
        this.state = {
            leftArrowDisabled: true,
            rightArrowDisabled: true,
            showArrows: false
        }
    }

    componentDidMount() {
        this.setArrows(0)
        this.windowResize = this.windowResize.bind(this)
        window.addEventListener('resize', this.windowResize)

        if (this.scrollView && this.scrollView.scrollWidth > this.scrollView.clientWidth) {
            this.setState({ showArrows: true })
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.windowResize)
    }

    windowResize() {
        this.setArrows(this.scrollView ? this.scrollView.scrollLeft : 0)
    }

    private getOffset() {
        switch (this.props.size) {
            case "news":
                return NEWS_WIDTH + MARGIN_L * 2
            case 'xlarge':
            case "large":
                return LARGE_IMG + MARGIN_L * 2
            case "small":
                return SMALL_IMG + MARGIN_S * 2
            case "video":
                return VIDEO_IMG_W + MARGIN_S * 2
        }
    }

    render() {
        const { items, style, headline, onViewAllClick, size, itemStyle } = this.props
        return (
            <div ref={e => this.container = e} style={style}>
                <div className="coverlist-header">
                    {headline && <span className="headline">{headline}</span>}
                    {onViewAllClick && <span className="viewall" onClick={onViewAllClick}>{'See All'}</span> || <span className="viewall"></span>}
                    {this.state.showArrows && <div className="arrow-container">
                        <div className="arrow" style={{ cursor: this.state.leftArrowDisabled ? "auto" : "pointer" }} onClick={() => {
                            this.scrollView && this.scrollElements(this.scrollView, -this.getOffset(), 500)
                        }}>
                            <img src={this.state.leftArrowDisabled ? ARROW_LEFT_SVG : ARROW_LEFT_SVG} />
                        </div>
                        <div className="arrow" style={{ cursor: this.state.rightArrowDisabled ? "auto" : "pointer" }} onClick={() => { this.scrollView && this.scrollElements(this.scrollView, this.getOffset(), 500) }}>
                            <img src={this.state.rightArrowDisabled ? ARROW_RIGHT_SVG : ARROW_RIGHT_SVG} />
                        </div>
                    </div>}
                </div>
                <div ref={(element) => this.scrollView = element} onScroll={() => this.scrollView && this.setArrows(this.scrollView.scrollLeft)} style={{ display: "flex", flex: 1, overflowX: "scroll" }} className="no-scrollbar list">
                    {items.map((item, index) => {
                        if (this.props.renderItem) {
                            return this.props.renderItem(item)
                        }
                        return (
                            <CoverListItem
                                style={itemStyle}
                                key={item.id}
                                cover={item.image}
                                headline={item.title}
                                subhead={item.subTitle}
                                first={index == 0}
                                last={index == items.length - 1}
                                size={size}
                                onClick={item.onClick}
                            />
                        )
                    })
                    }
                </div>
            </div>
        )
    }
    private scrollElements(element: HTMLDivElement, offset: number, duration: number) {
        var start = element.scrollLeft;
        var currentTime = 0;
        var increment = 20;
        offset = this.getNewOffset(start, offset)

        let _requestCode = ++this.scrollRequestCode;
        var animateScroll = () => {
            if (_requestCode !== this.scrollRequestCode) {
                return;
            }

            currentTime += increment;
            var val = this.easeInOutQuad(currentTime, start, offset, duration);
            element.scrollLeft = val;
            this.setArrows(element.scrollLeft)
            if (currentTime < duration) {
                setTimeout(animateScroll, increment);
            }
        };
        animateScroll();
    }

    private easeInOutQuad(currentTime: number, startValue: number, offset: number, duration: number) {		//https://stackoverflow.com/questions/52747018/horizontal-scrolling-using-buttons-in-reactjs
        currentTime /= duration / 2;
        if (currentTime < 1) {
            return offset / 2 * currentTime * currentTime + startValue;
        }
        currentTime--;
        return -offset / 2 * (currentTime * (currentTime - 2) - 1) + startValue;
    }

    private getNewOffset(start: number, offset: number): number {
        let rest = start % offset
        return rest < Math.abs(offset) / 2 ? offset - rest : (offset - rest) + Math.abs(offset)
    }

    private setArrows(start: number) {
        let leftDisabled = start == 0
        if (leftDisabled != this.state.leftArrowDisabled) {
            this.setState({
                leftArrowDisabled: leftDisabled
            })
        }
        if (this.container) {
            let end = this.props.items.length
            let rightDisabled = end * this.getOffset() - 30 <= start + this.container.offsetWidth
            if (rightDisabled != this.state.rightArrowDisabled) {
                this.setState({
                    rightArrowDisabled: rightDisabled
                })
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/views/HorizontalList.tsx